import Core from '../core';
import { AxiosError } from 'axios';

async function myTeam(
  company_id: number,
  department_id: number,
  empId: number,
  userId: number,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/employeesByDepartmentEmpPortal?company_id=${company_id}&department_id=${department_id}&emp_id=${empId}&user_id=${userId}&full_path=true&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

export const myTeamService = {
  myTeam,
};
